import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/contents/tms/tms-clinical-study-results",
)({
  beforeLoad: () => {
    throw redirect({
      to: "/learn/$slug",
      params: { slug: "saint-tms-success-rates" },
      replace: true,
    });
  },
});
